var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M505.965 368.68a6.183 6.183 0 0 0-.35-2.33 7.992 7.992 0 0 0-1.07-2.11c-.119-.189-94.117-125.392-94.25-125.58l35-87.5h20.35a8.06 8.06 0 0 0 8.06-8.06V78.58a8 8 0 0 0-8.06-8.06H46.285a8 8 0 0 0-8.06 7.94c-.03.108.021 64.522 0 64.64a8.06 8.06 0 0 0 8.06 8.06h20.35l35 87.5c-.043.067-94.135 125.491-94.18 125.579a8.192 8.192 0 0 0-1.19 2.5 6.769 6.769 0 0 0-.23 2.16v64.52a8.06 8.06 0 0 0 8.06 8.06h483.81a8.06 8.06 0 0 0 8.06-8.06zm-24.19-7.84h-27.95l-59.52-89.29 8.2-16.4zm-101.76-96.78h-248.05l-8.07-16.12h264.19zm-248.77 16.13h249.44l53.76 80.65h-146.22a8.061 8.061 0 0 0-8.07 8.05 24.19 24.19 0 1 1-48.38.01 8.061 8.061 0 0 0-8.06-8.06H77.485zM54.355 86.65h403.22V135H54.355zm29.61 64.51h344l-32.26 80.65h-279.45zm25.43 104 8.2 16.4-59.49 89.28h-27.94zm380.41 170.2H22.1V377h194.35c9.009 42.53 70.029 42.431 79 0h194.39z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000",
    className: "hovered-path"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/Pizza.0259a0b7578eccb0fd2ddd1b500e4916.svg";
export { ForwardRef as ReactComponent };